import { Component, Input, OnInit } from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";

@Component({
  selector: "ngx-dialog-images-upload",
  templateUrl: "dialog-images-upload.component.html",
  styleUrls: ["dialog-images-upload.component.scss"],
})
export class DialogImagesUploadComponent implements OnInit {
  @Input() mode?: string; //firebase / amazons3 / imagekit
  @Input() path?: string; //users/avatars / /users/uploads :( not compress images) / /users/images : compress 400x400

  submitted = false;
  loading = false;
  loadingProfile = false;

  constructor(protected ref: NbDialogRef<DialogImagesUploadComponent>) {}

  ngOnInit() {
    if (!this.mode || this.mode == "") {
      this.mode = "imagekit";
    }
    if (!this.path || this.path == "") {
      this.path = "/users/images";
    }
  }

  close() {
    this.ref.close();
  }

  selectedImage(value) {
    if (value) {
      this.ref.close({ isNew: false, value: value });
    }
  }

  uploadImage(value) {
    if (value) {
      this.ref.close({ isNew: true, value: value });
    }
  }
}
